import axios from 'axios';

const customerService = {
  async save(customer) {
    return axios.put('/customers/save', customer);
  },
  async getCategories() {
    return axios.get('/customers/categories');
  },
  async getById(id) {
    return axios.get(`/customers/${id}`);
  },
  async findByDocumentAndOfficeId(document, officeId) {
    return axios.get(`/customers/find-by-document-and-office?document=${document}&officeId=${officeId}`)
  }
};

export default customerService;
